import { render, staticRenderFns } from "./PatentPdfViewer.vue?vue&type=template&id=3154d80a&scoped=true"
import script from "./PatentPdfViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatentPdfViewer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PatentPdfViewer.vue?vue&type=style&index=0&id=3154d80a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3154d80a",
  null
  
)

export default component.exports